import { IBaseDropdownItem } from './types'

export const getFilteredItems = <T>({
  items,
  searchQuery,
  searchKeys
}: {
  items: T[]
  searchQuery: string
  searchKeys: string[]
}) => {
  if (!searchQuery) return items
  const query = searchQuery.toLowerCase()
  return items.filter(item =>
    searchKeys.some(key =>
      String(item[key as keyof T])
        .toLowerCase()
        .includes(query)
    )
  )
}

export const getActiveItem = <T extends IBaseDropdownItem>({
  items,
  selectedItemId
}: {
  items: T[]
  selectedItemId: string | number
}) => {
  return items.find(item => item.id === selectedItemId) || null
}
